@if (clusters()?.length !== 0) {
  <section class="review-slider">
    <header class="heading">
      <h2>{{ 'PAGES.LANDING.REVIEWS_TITLE' | translate }}</h2>
      <p>
        {{
          'PAGES.LANDING.REVIEWS_SUBTITLE'
            | translate: { tasks: (statistics().tasks | number)! }
        }}
      </p>
    </header>

    <div class="pills">
      @for (cluster of clusters(); track cluster.id) {
        <button
          type="button"
          class="pill"
          [class.active]="cluster.id === selectedClusterId()"
          [attr.aria-pressed]="cluster.id === selectedClusterId()"
          (click)="select(cluster.id)"
        >
          <ui-icon [name]="iconName(cluster)" variant="stroke" />
          {{ cluster.name }}
        </button>
      }
    </div>

    @if (lanes(); as lanes) {
      <!-- Lanes and cards are reused across a switch: only their bindings change, and the
         marquee keeps running. -->
      @for (lane of lanes; track $index) {
        <div class="lane" [class.reverse]="$odd">
          <div class="track" [style.animation-duration]="laneDuration(lane)">
            @for (copy of [false, true]; track copy) {
              <div
                class="copy"
                [class.duplicate]="copy"
                [attr.aria-hidden]="copy ? 'true' : null"
              >
                @for (card of lane; track $index) {
                  <a
                    class="review-card"
                    [class.padding]="card.isPadding"
                    [href]="card.url"
                    [attr.tabindex]="copy || card.isPadding ? -1 : null"
                    [attr.aria-hidden]="!copy && card.isPadding ? 'true' : null"
                  >
                    <div class="top">
                      <div>
                        <div
                          class="rating"
                          role="img"
                          [attr.aria-label]="ratingLabel(card.rating)"
                        >
                          <ui-stars [rating]="card.rating" />
                        </div>
                        <p class="reviewer">
                          {{ card.reviewerName }}
                          @if (card.city) {
                            <span class="separator">·</span> {{ card.city }}
                          }
                        </p>
                      </div>
                      <ui-avatar
                        [user]="card.reviewer"
                        size="44px"
                        [decorative]="true"
                      />
                    </div>
                    <span class="title">{{ card.title }}</span>
                    <p class="message">{{ card.message }}</p>
                    <footer>
                      <span>{{ formatDate(card.createdAt) }}</span>
                      @if (card.price !== null) {
                        <span class="separator">·</span>
                        <b class="price">{{
                          card.price | formatCurrency: card.currencyCode || null
                        }}</b>
                      }
                      @if (card.handyhanderName) {
                        <span class="separator">·</span>
                        <span class="done-by"
                          >{{ 'PAGES.LANDING.REVIEWS_DONE_BY' | translate }}
                          <span class="name">{{
                            card.handyhanderName
                          }}</span></span
                        >
                      }
                    </footer>
                  </a>
                }
              </div>
            }
          </div>
        </div>
      }
    } @else {
      <div class="lane skeleton">
        <div class="card-skeleton"></div>
        <div class="card-skeleton"></div>
        <div class="card-skeleton"></div>
      </div>
      <div class="lane skeleton">
        <div class="card-skeleton"></div>
        <div class="card-skeleton"></div>
        <div class="card-skeleton"></div>
      </div>
    }
  </section>
}
